const Chevron2 = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.333 17.5L19.9997 24.1667L26.6663 17.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default Chevron2;
